<template>
  <div class="container-fluid">
    <div class="mt-3 my-md-4">
      <dx-back-text-button
        :text="$t('damageBacklog.overview')"
        :route="localePath('SelfService')"
        class="overview"
      />
    </div>
    <div class="content-wrap-medium content-pad">
      <h3 class="mb-5">
        {{ $t('userData.userDataHeading') }}
      </h3>

      <dx-change-login-details />

      <div class="row user-data-block last-item">
        <div class="col">
          <dx-edit-data-toggle
            :headline="$t('userData.personalData')"
            tag-type="h4"
            :callback="changePersonalData"
            :cancel-callback="cancelPersonalData"
            :show="this.$store.getters.isDexPolicyholder"
          >
            <template
              slot="data-dynamic"
              slot-scope="{ editMode }"
            >
              <dx-personal-data-form
                ref="personalDataForm"
                :editable="editMode"
              />
            </template>
          </dx-edit-data-toggle>
        </div>
      </div>

      <!-- TODO: Bank Details for Customer not yet available -->
      <div
        v-if="false"
        class="row user-data-block"
      >
        <div class="col">
          <dx-edit-data-toggle
            :headline="$t('userData.paymentData')"
            tag-type="h4"
            :callback="() => {}"
          >
            <template
              slot="data-dynamic"
              slot-scope="{ editMode }"
            >
              <dx-bank-details-form
                ref="bankDetailsForm"
                :editable="editMode"
              />
            </template>
          </dx-edit-data-toggle>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DxEditDataToggle from '~/components/DX-EditDataToggle'
import DxChangeLoginDetails from '~/domains/authentication/components/DX-ChangeLoginDetails'
import DxPersonalDataForm from '~/domains/user/components/DX-PersonalDataForm'
import DxBankDetailsForm from '~/domains/user/components/DX-BankDetailsForm'
import { DxBackTextButton } from '@sumcumo/dextra-frontend-component-lib'

export default {
  name: 'DxUserPersonalData',
  components: {
    DxEditDataToggle,
    DxChangeLoginDetails,
    DxPersonalDataForm,
    DxBankDetailsForm,
    DxBackTextButton,
  },
  methods: {
    async changePersonalData() {
      const result = await this.$refs.personalDataForm.editAddressCallback()
      return result
    },
    async cancelPersonalData() {
      const result = await this.$refs.personalDataForm.cancelCallback()
      return result
    },
  },
  nuxtI18n: {
    paths: {
      de: '/kundencenter/benutzerdaten',
      fr: '/centre-clients/donnees-utilisateur',
      it: '/centro-clienti/informazioni-utente',
    },
  },
}
</script>
